(function () {

    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {

        module.exports = definition();

    } else {

        RivalIQ.module('enums');
        RivalIQ.enums.facebookAdCampaignObjectives = definition();

    }

    function definition() {

        return {
            APP_INSTALLS: {
                id: 'APP_INSTALLS',
                name: 'App Installs',
                resultsMetric: 'actions_mobile_app_install',
                costPerResultMetric: 'cost_per_action_type_mobile_app_install'
            },
            AD_RECALL_LIFT: {
                id: 'AD_RECALL_LIFT',
                name: 'Ad Recall Lift',
                resultsMetric: 'estimated_ad_recallers',
                costPerResultMetric: 'cost_per_estimated_ad_recallers'
            },
            BRAND_AWARENESS: {
                id: 'BRAND_AWARENESS',
                name: 'Brand Awareness',
                resultsMetric: 'estimated_ad_recallers',
                costPerResultMetric: 'cost_per_estimated_ad_recallers'
            },
            CANVAS_APP_ENGAGEMENT: {
                id: 'CANVAS_APP_ENGAGEMENT',
                name: 'Canvas App Engagement',
                unverified: true
            },
            CANVAS_APP_INSTALLS: {
                id: 'CANVAS_APP_INSTALLS',
                name: 'Canvas App Installs',
                unverified: true
            },
            CONVERSIONS: {
                id: 'CONVERSIONS',
                name: 'Conversions',
                resultsMetric: 'actions_offsite_conversion',
                costPerResultMetric: 'cost_per_action_type_offsite_conversion'
            },
            EVENT_RESPONSES: {
                id: 'EVENT_RESPONSES',
                name: 'Event Responses',
                resultsMetric: 'actions_rsvp',
                costPerResultMetric: 'cost_per_action_type_rsvp'
            },
            EXTERNAL: {
                id: 'EXTERNAL',
                name: 'External',
                unverified: true
            },
            LEAD_GENERATION: {
                id: 'LEAD_GENERATION',
                name: 'Lead Generation',
                resultsMetric: 'actions_leadgen_grouped',
                costPerResultMetric: 'cost_per_action_type_leadgen_grouped'
            },
            LINK_CLICKS: {
                id: 'LINK_CLICKS',
                name: 'Traffic',
                resultsMetric: 'actions_link_click',
                costPerResultMetric: 'cost_per_action_type_link_click'
            },
            LOCAL_AWARENESS: {
                id: 'LOCAL_AWARENESS',
                name: 'Local Awareness',
                resultsMetric: 'actions_checkin',
                costPerResultMetric: 'cost_per_action_type_checkin'
            },
            MESSAGES: {
                id: 'MESSAGES',
                name: 'Messages',
                resultsMetric: 'actions_onsite_conversion__messaging_conversation_started_7d',
                costPerResultMetric: 'cost_per_action_type_onsite_conversion__messaging_conversation_started_7d'
            },
            MOBILE_APP_ENGAGEMENT: {
                id: 'MOBILE_APP_ENGAGEMENT',
                name: 'Mobile App Engagement',
                unverified: true,
                resultsMetric: 'actions_app_use',
                costPerResultMetric: 'cost_per_action_type_app_use'
            },
            MOBILE_APP_INSTALLS: {
                id: 'MOBILE_APP_INSTALLS',
                name: 'Mobile App Installs',
                unverified: true,
                resultsMetric: 'actions_app_install',
                costPerResultMetric: 'cost_per_action_type_app_install'
            },
            OFFER_CLAIMS: {
                id: 'OFFER_CLAIMS',
                name: 'Offer Claims',
                resultsMetric: 'actions_receive_offer',
                costPerResultMetric: 'cost_per_action_type_receive_offer'
            },
            PAGE_LIKES: {
                id: 'PAGE_LIKES',
                name: 'Page Likes',
                resultsMetric: 'actions_like',
                costPerResultMetric: 'cost_per_action_type_like'
            },
            POST_ENGAGEMENT: {
                id: 'POST_ENGAGEMENT',
                name: 'Post Engagement',
                resultsMetric: 'actions_post_engagement',
                costPerResultMetric: 'cost_per_action_type_post_engagement'
            },
            PRODUCT_CATALOG_SALES: {
                id: 'PRODUCT_CATALOG_SALES',
                name: 'Product Catalog Sales',
                resultsMetric: 'actions_offsite_conversion__fb_pixel_purchase',
                costPerResultMetric: 'cost_per_action_type_offsite_conversion__fb_pixel_purchase'
            },
            REACH: {
                id: 'REACH',
                name: 'Reach',
                resultsMetric: 'reach',
                costPerResultMetric: 'cpp'
            },
            VIDEO_VIEWS: {
                id: 'VIDEO_VIEWS',
                name: 'Video Views',
                resultsMetric: 'actions_video_view',
                costPerResultMetric: 'cost_per_action_type_video_view'
            }
        };
    }
})();
